import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
  excelWorksheetName,
  toYesNoNa,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Environment approval (clearance)";

const SHEET_TITLE =
  "If the entity has operations/offices in/around ecologically sensitive areas (such as national parks, wildlife sanctuaries, biosphere reserves, wetlands, biodiversity hotspots, forests, coastal regulation zones etc.) where environmental approvals / clearances are required, please specify details in the following format:";

export function buildEnvironmentApprovalSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(excelWorksheetName(SHEET_NAME), {
    views: [{ showGridLines: true }],
  });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 28;
  ws.getColumn("F").width = 20;
  ws.getColumn("G").width = 28;
  ws.getColumn("H").width = 36;

  const rows = sectionC?.principle6?.essentialIndicators?.environmentalApproval || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, { mergeEnd: COL_H });

  mergeRow(ws, TITLE_ROW, COL_D, COL_H, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Location of operations/offices", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "Type of operations", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(
    ws,
    HEADER_ROW,
    COL_G,
    "Whether the conditions of environmental approval / clearance are being complied with?",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  setCell(ws, HEADER_ROW, COL_H, "If no, the reasons thereof and corrective action taken, if any.", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.location), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.operation), { align: "left" });
    setCell(ws, row, COL_G, toYesNoNa(item?.approval), { align: "center" });
    setCell(ws, row, COL_H, safeText(item?.reason, ""), { align: "left" });
  });

  return ws;
}
